import { ImageLoaderConfig } from '@angular/common';

/**
 * Loader para NgOptimizedImage que convierte URLs de Cloudinary en versiones
 * redimensionadas (`w_<width>`) y formateadas con f_auto/q_auto para servir el
 * tamaño y formato más eficiente según el dispositivo.
 */
export function cloudinaryImageLoader(config: ImageLoaderConfig): string {
  const { src, width } = config;
  const marker = '/image/upload/';
  const idx = src.indexOf(marker);
  if (idx === -1) return src;

  const before = src.slice(0, idx + marker.length);
  const tail = src.slice(idx + marker.length);

  // Public IDs con versión (p.ej. v1234567890/abc123.jpg)
  const segments = tail.split('/');
  if (segments[0] && /^v\d+$/.test(segments[0])) {
    return `${before}w_${width}/${tail}`;
  }

  // Transformaciones ya existentes (p.ej. f_auto,q_auto)
  const transform = segments[0] || '';
  const parts = transform.split(',').filter(Boolean);
  if (!parts.some((p) => p.startsWith('w_'))) {
    parts.push(`w_${width}`);
  }
  return `${before}${parts.join(',')}/${segments.slice(1).join('/')}`;
}
